// @flow
import * as React from 'react';
import { hydrate } from 'react-dom';
import Default from '../default';
import CommunityActivityLayout from './layout';
import { read } from '../../utils/cookie';
import {getBasename, isSupportedMobile, isStagingEnv} from '../../utils';
import ClientProvider from '../ClientProvider';

class CommunityActivityApp extends Default {
    constructor(reducers: Array<string>, sagas: Array<string>, layout: Function | React.ComponentType<any>) {
        super(reducers, sagas, layout);
    }

    render(container: ?Object): any {
        const Layout = this.layout;
        const basename = getBasename(location.pathname);
        const isMobile = isSupportedMobile();

        return hydrate(
            <ClientProvider basename={basename} store={this.store}>
                <Layout lang={read('lang')} isMobile={ isMobile }/>
            </ClientProvider>, container || this.container);
    }
}

let app = new CommunityActivityApp(['lastAction', 'recentReviews'], ['recentReviewsSaga'], CommunityActivityLayout);

app.render();

if (isStagingEnv()) {
    window.app = app;
}
